import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';

import type {
  ITFAGenerateResponse,
  ITFASchema,
} from '../types';
import {
  ADMIN_PROFILE_SETTINGS_TFA_GENERATE_URL,
  AFFILIATE_PROFILE_SETTINGS_TFA_GENERATE_URL,
  PROFILE_SETTINGS_TFA_GENERATE_MUTATION_KEY,
} from '../constants';

export default function useProfileSettingsTFAGenerateMutation(): IContextMutationResult<
  ITFAGenerateResponse,
  Error,
  ITFASchema
> {
  const { fetchPost } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<ITFAGenerateResponse, Error, ITFASchema>({
    mutationKey: [PROFILE_SETTINGS_TFA_GENERATE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<ITFAGenerateResponse>(
      isAdminNamespace.value ? ADMIN_PROFILE_SETTINGS_TFA_GENERATE_URL : AFFILIATE_PROFILE_SETTINGS_TFA_GENERATE_URL,
      isAdminNamespace.value ? { admin: payload } : { affiliate: payload },
      {
        permission: PROFILE_SETTINGS_PERMISSIONS.TWO_FACTOR_AUTH,
      },
    ),
  });
}
